<template>
  <svg :width="width" :height="height" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
    <path d="M2 3h16v11H2V3z" opacity="0.3"/>
    <path d="M2 14h7v3H2v-3zm9 0h7v3h-7v-3z"/>
    <path d="M7 15.5l2-1.5v1h2v1H9v1l-2-1.5zm6 0l2-1.5v1h2v1h-2v1l-2-1.5z" transform="rotate(180 10 15.5)"/>
  </svg>
</template>

<script>
export default {
  name: 'SplitCell',
  props: {
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    }
  }
}
</script>
